import React, { useEffect } from 'react';
import './App.css';
import axios from 'axios';
import Header from './components/shared/Header';
import Footer from './components/shared/Footer';
import LeftPanel from './components/shared/LeftPanel';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import './style.css';
import './template.css';
import './cs-skin-elastic.css';
import DataApp,{ DataAppContext } from './DataContext';
import 'react-toastify/dist/ReactToastify.css';
import Home from './components/common/Home';
import Login from './components/common/Login';
import ContactList from './components/admin/Contact/ContactList';
import ContactAdd from './components/admin/Contact/ContactAdd';
import ContactView from './components/admin/Contact/ContactView';
import ContactEdit from './components/admin/Contact/ContactEdit';


import DashboardAdmin from './components/admin/DashboardAdmin';
import AdminNotice from './components/admin/Notice';

import UsersList from './components/admin/UsersList';
import UserAdd from './components/admin/UserAdd';
import UserUpdate from './components/admin/UserUpdate';
import Profile from './components/common/Profile';
import EmployersUserList from './components/admin/EmployersUserList';

import Skills from './components/admin/Skills';
import SkillsAdd from './components/admin/SkillsAdd';
import SkillsUpdate from './components/admin/SkillsUpdate';

// import CompanyAdd from './components/admin/CompanyAdd';
// import CompanyList from './components/admin/Companylist';
// import CompanyUpdate from './components/admin/CompanyEdit';

import CityList from './components/admin/CityList'
import CityAdd from './components/admin/CityAdd'
import CityEdit from './components/admin/CityEdit'
import JobList from './components/admin/JobList';
import JobAdd from './components/admin/JobAdd';
import JobUpdate from './components/admin/JobUpdate';
import JobDetailsAdd from './components/admin/JobDetailsAdd';
import JobDetailsUpdate from './components/admin/JobDetailsUpdate';
import JobDetailedDescription from './components/admin/JobDetailedDescription';
import HrList from './components/admin/HrList';
import HrAdd from './components/admin/HrAdd';
import HrUpdate from './components/admin/HrUpdate';

import JobCategory from './components/admin/JobCategory';
import CandidateList from './components/admin/CandidateList';
import CandidateAdd from './components/admin/CandidateAdd';
import CandidateUpdate from './components/admin/CandidateUpdate';
import CompaniesList from './components/admin/Companies/CompaniesList';
import CompaniesAdd from './components/admin/Companies/CompaniesAdd';
import CompaniesEdit from './components/admin/Companies/CompaniesEdit';
import CompaniesView from './components/admin/Companies/CompaniesView';
import NoticeAdd from './components/admin/NoticeAdd';
import NoticeList from './components/admin/NoticeList';
import NoticeUpdate from './components/admin/NoticeUpdate';
import AddCategory from './components/admin/AddCategory';
import UpdateCategory from './components/admin/UpdateCategory';
import Department from './components/admin/Department';
import EditDepartment from './components/admin/EditDepartment';

import Complaints from './components/admin/Complaints';
import ComplaintsView from './components/admin/ComplaintsView';

import OurTeam from './components/admin/ourteam';
import AddNewTeamMember from './components/admin/ourteamadd';
import OurTeamEdit from './components/admin/ourteamedit';
import JobApplications from './components/admin/JobApplications';
import CandidateDetails from './components/admin/CandidateDetails';
import Feedback from './components/admin/feedback';
import Industries from './components/admin/Industries';
import AddNewIndustry from './components/admin/Industryadd';
import IndustryEdit from './components/admin/Industryedit';
import Testimonials from './components/admin/Testimonials';
import TestimonialAdd from './components/admin/TestimonialAdd';
import TestimonialEdit from './components/admin/TestimonialEdit';
import Interviews from './components/admin/Interviews';
import InterviewReschedule from './components/admin/interviewreschedule';
import FAQPage from "./components/admin/FAQPage"; 
import FAQAdd from "./components/admin/FAQAdd";
import FAQEdit from './components/admin/FAQEdit';
import DegreeList from './components/admin/Degree/DegreeList';
import DegreeAdd from './components/admin/Degree/DegreeAdd';
import UpdateDegree from './components/admin/Degree/DegreeEdit';
import DegreeEdit from './components/admin/Degree/DegreeEdit';


function App() {
  // /  temp code to run server continuously comment this code before deployment
    //  const callApiQsList = async () => {
    //   try {
    //     const url = process.env.REACT_APP_API_URL + 'settings/allsettings';
    //     const response = await axios.get(url);
    //   }
    //   catch (error) { console.log(error); }
    // }
  
    // useEffect(() => {
    //   setInterval(() => callApiQsList(), 30000)
    // }, []) 

  return (
    <>
    <BrowserRouter>
      <DataApp>
        <DataAppContext.Consumer>
          {({ appstate }) => (
           <>
              {appstate.loginstatus && <LeftPanel />}
            <div id="right-panel" className="right-panel" style={{
                  marginLeft: appstate.leftPanelVisible ? '' : '0', 
                  width: appstate.leftPanelVisible ? '' : '100%',
                  transition: 'all 0.3s'
                }}>
              <Header />
              <div className='row maincontent content  p-2'>

                <div className='col-12 scrollPage'>
                  <Routes>
                    <Route path='/profile' element={<Profile />} />
                    <Route path='/admindashboard' element={<DashboardAdmin />} />
                    <Route path='/adminnotice' element={<AdminNotice />} />
                    <Route path='/home' element={<Home />} />
                    <Route path='/login' element={<Login />} />
                    <Route path='/userslist' element={<UsersList />} />
                    <Route path='/employerusers' element={<EmployersUserList />} />
                    <Route path='/useradd' element={<UserAdd />} />
                    <Route path='/useredit/:id' element={<UserUpdate />} />
                    <Route path='/contactAdd' element={<ContactAdd/>} />
                    <Route path='/ContactEdit/:contactid' element={<ContactEdit/>} />
                    <Route path='/ContactView/:contactid' element={<ContactView/>} />
                    <Route path='/contactList' element={<ContactList/>} />

                    {/* <Route path='/CompanyDetails' element={<Company />} /> */}
                    {/* <Route path='/CompanyAdd' element={<CompanyAdd />} />
                    <Route path='/CompanyEdit/:id' element={<CompanyUpdate />} />
                    <Route path='/Companylist' element={<CompanyList />} /> */}
                    <Route path='/noticeadd' element={<NoticeAdd />} />
                    <Route path='/noticelist' element={<NoticeList />} />
                    <Route path='/noticeupdate/:id' element={<NoticeUpdate />} />

                    <Route path='/citylist' element={<CityList />} /> */
                    {/* <Route path='/citieslist' element={<CityList />} /> */}
                    <Route path='/cityadd' element={<CityAdd />} />
                    <Route path='/cityedit/:cityId' element={<CityEdit />} />

                    <Route path='/skills' element= {<Skills />} />
                    <Route path='/skillsadd' element= {<SkillsAdd />} />
                    <Route path='/skillsupdate/:id' element ={<SkillsUpdate />} />
                    <Route path='/' element={<DashboardAdmin />} />

                    <Route path='/department' element={<Department/>}/>
                    <Route path="/updatedepartment/:id" element={<EditDepartment />} />                

                    <Route path='/candidate-details/:id' element={<CandidateDetails/>}/>
                    <Route path='/job-applications' element={<JobApplications />} />
                    <Route path='/job-applications' element={<JobApplications />} />
                    <Route path='/joblist' element={<JobList />} />
                    <Route path='/jobadd' element={<JobAdd />} />
                    <Route path='/jobupdate/:jobid' element={<JobUpdate />} />
                    <Route path='/jobdetailsadd/:jobid' element={<JobDetailsAdd />} />
                    <Route path='/jobdetailsupdate/:jobid' element={<JobDetailsUpdate />} />
                    <Route path='/job-detailed-description/:jobid' element={<JobDetailedDescription />} />

                    <Route path='/categories' element={<JobCategory />} />
                    <Route path='/add_category' element={<AddCategory/>}/>
                    <Route path='/update_category/:categoryid' element={<UpdateCategory/>}/>


                    <Route path='/hrlist' element={<HrList/>}/>
                    <Route path='/hradd' element={<HrAdd/>}/>
                    <Route path='/hrupdate/:id'element={<HrUpdate/>}/>

                    <Route path='/candidate_details' element={<CandidateList />} />
                    <Route path='/candidateadd' element={<CandidateAdd />} />
                    <Route path='/candidate_update/:candidateId' element={<CandidateUpdate />} />


                    <Route path='/companieslist' element={<CompaniesList />} />
                    <Route path='/companiesadd' element={<CompaniesAdd/>} />
                    <Route path='/companiesedit/:company_id' element={<CompaniesEdit />} />
                    <Route path='/companiesview/:company_id/:userid' element={<CompaniesView />} />

                    <Route path='/Complaints' element={<Complaints />} />
                    <Route path="/ComplaintsView/:id" element={<ComplaintsView />} />

                    <Route path='/ourteam' element={<OurTeam />} />
                    <Route path='/ourteamadd' element={<AddNewTeamMember />} />
                    <Route path='/ourteamedit/:id' element={<OurTeamEdit />} />

                   <Route path='/feedback' element={<Feedback />} />
                   
                   <Route path='/industries' element={< Industries />} />
                   <Route path='/industryadd' element={< AddNewIndustry />} />
                   <Route path='/industryedit/:id' element={< IndustryEdit />} />

                   <Route path='/testimonials' element={<Testimonials/>} />                  
                   <Route path='/testimonialadd' element={<TestimonialAdd/>} />
                   <Route path='/testimonialedit/:id' element={<TestimonialEdit/>} />

                   <Route path='/interviews' element={<Interviews/>} />
                   <Route path="/interviewreschedule" element={<InterviewReschedule />} />

                   <Route path="/FAQPage" element={<FAQPage />} /> 
                   <Route path="/FAQAdd" element={<FAQAdd />} />
                   <Route path="/faqs/edit/:faq_id" element={<FAQEdit />} />
                   
                   <Route path="/degreelist" element={<DegreeList />} /> 
                   <Route path="/degreeadd" element={<DegreeAdd />} />
                   <Route path="/degree/edit/:d_id" element={<DegreeEdit />} />
                    
                  </Routes>
                </div>

              </div>
              <Footer />
            </div>
          </>
       )}
       </DataAppContext.Consumer>
     </DataApp>
   </BrowserRouter>
   </>
  );
}

export default App;
